var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPasskeymin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9.063a1.25 1.25 0 1 1-.001 2.501 1.25 1.25 0 0 1 .001-2.501"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.627 4.774A5.62 5.62 0 0 1 10.49 7.5h6.257c.28 0 .545.095.76.258l.089.074.008.008 2.003 1.882.002.001c.51.481.528 1.293.026 1.794l-2.734 2.735a1.25 1.25 0 0 1-1.769 0l-.586-.586-.586.586a1.25 1.25 0 0 1-1.767 0l-1.127-1.127h-.578a5.61 5.61 0 0 1-4.863 2.813 5.632 5.632 0 0 1-5.474-6.94l.102-.382a5.61 5.61 0 0 1 4.11-3.79zm4.431 4.04a3.755 3.755 0 0 0-4.293-2.157h.001c-1.359.3-2.48 1.406-2.788 2.758-.564 2.472 1.288 4.648 3.647 4.648a3.75 3.75 0 0 0 3.433-2.251l.065-.122a.94.94 0 0 1 .794-.44h1.537c.249 0 .487.1.663.275l.96.96.806-.807a.94.94 0 0 1 1.326 0l.807.806 1.837-1.837L16.5 9.375H9.918a.94.94 0 0 1-.859-.561",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPasskeymin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_passkey.min.d349241cbd292686d64444f5eaf263f4.svg";